/**
 * 弹窗类型枚举
 */
export enum AlertType {
    /**
     * 不弹窗
     */
    NONE = 0,
    /**
     * 弱提示弹窗
     */
    SUBTLE = 1,
    /**
     * 强提示弹窗
     */
    STRONG = 2,
}

/**
 * 业务线类型枚举
 */
export enum BizOrgCode {
    /**
     * 外卖
     */
    WAIMAI = 14010,
    /**
     * 闪购
     */
    SHANGOU = 14060,
    /**
     * 医药
     */
    YIYAO = 14090,
}
